import Link from 'next/link';
import React, { useState } from 'react';
import { convertToUrl } from 'src/utils/convertToUrl';
import { formatNumber } from 'src/utils/format';
import { capitalizeString } from 'src/utils/string';

const getWidth = (obj: {
  id: string;
  label: string;
  value: number;
  percentage: number;
}) => {
  const widthPercentage = Math.ceil(obj.percentage);
  return `${widthPercentage}%`;
};

type ListWithLinksProps = {
  // eslint-disable-next-line
  data: any;
  href: string;
  page: number;
  nrOfElementsPerPage: number;
  // eslint-disable-next-line
  onClick?: any;
  title?: string;
  countryIso2?: string;
};

export default function ListWithLinks({
  data,
  href,
  page,
  nrOfElementsPerPage,
  onClick,
  title,
  countryIso2,
}: ListWithLinksProps) {
  const [isItemHovered, setIsItemHovered] = useState<string>('');

  const handleHover = (id: string) => {
    setIsItemHovered(id);
  };

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    label: string
  ) => {
    event.preventDefault();
    onClick &&
      onClick(
        `${href}/${convertToUrl(label)}${
          countryIso2 ? `?country=${countryIso2}` : ''
        }`
      );
  };

  return data?.length > 0 ? (
    <div className="shrink grow basis-0 gap-6 rounded-xl bg-white p-6 shadow-[0px_2px_16px_-4px_rgba(9,9,11,0.08)]">
      <h5 className="text-lg font-semibold">{title}</h5>
      <ul className="flex max-h-[480px] w-full flex-col overflow-y-auto py-2 lg:py-4">
        {data?.map(
          (
            obj: {
              id: string;
              label: string;
              value: number;
              percentage: number;
            },
            index: number
          ) => (
            <li
              key={obj.id}
              onMouseEnter={() => handleHover(obj.id)}
              onMouseLeave={() => handleHover(' ')}
              className="relative flex hover:opacity-70 "
            >
              <Link
                className="flex w-full justify-between gap-x-4 px-4 py-2 md:py-2"
                href={`${href}/${convertToUrl(obj.label)}${
                  countryIso2 ? `?country=${countryIso2}` : ''
                }`}
                onClick={(e) => handleClick(e, obj.label)}
              >
                <div className="flex items-center justify-between gap-3">
                  <p className="flex min-w-[150px] text-xs font-medium leading-6 text-gray-900 lg:text-sm">
                    {`${
                      (page - 1) * nrOfElementsPerPage + index + 1
                    }. ${capitalizeString(obj.label)}`}
                  </p>
                  <div
                    style={{ minWidth: getWidth(obj) }}
                    className={`h-4 self-center bg-gradient-to-l from-[#34a28a] to-[#34a28a]/20`}
                  />
                  <p className="text-xs leading-6 text-zinc-500 lg:text-[14px]">
                    {formatNumber(obj.value)}
                  </p>
                </div>
              </Link>
            </li>
          )
        )}
      </ul>
    </div>
  ) : (
    <></>
  );
}
